import { Col, Form, Row, Select, Spin } from 'antd';
import { createArea, createJobPosition } from '../../../../services/general';
import CreatableSelect from "../../../components/CreatableSelect";

const { Option } = Select;

const JobDataBlock = ({
  t,
  projects,
  loadingProjects,
  fetchProjects,
  areasList,
  jobPositionsList,
  form,
  reservationForm,
  onFieldsChange,
  handleAreaCreated,
  handleJobPositionCreated,
}) => {
  return (
    <Row gutter={15} className='mb-30 mt-xs-15 mt-md-0'>
      <Col lg={8} xs={24}>
        <Form.Item name="project_id" label={t('reservations.patientForm.projectLabel')} className="mb-0">
          <Select
            className="cmt-select"
            placeholder={t('reservations.patientForm.projectPlaceholder')}
            showSearch
            allowClear
            onSearch={fetchProjects}
            filterOption={false}
            notFoundContent={loadingProjects ? <Spin size="small" /> : null}
          >
            {projects?.length ? projects.map(project => (
              <Option key={project.id} value={project.id}>{project.name}</Option>
            )) : null}
          </Select>
        </Form.Item>
      </Col>
      <Col lg={8} xs={24} className="mt-xs-15 mt-sm-15 mt-lg-0">
        <CreatableSelect
          optionsList={areasList}
          label="Área"
          formName="area_id"
          createFn={(params) => createArea({ ...params, company_id: reservationForm?.getFieldValue('company_id') || form.getFieldValue('company_id') })}
          form={form}
          required={false}
          onItemCreated={(id, item) => {
            onFieldsChange([{ name: ['area_id'], value: id }]);
            handleAreaCreated(item);
          }}
        />
      </Col>
      <Col lg={8} xs={24} className="mt-xs-15 mt-sm-15 mt-lg-0">
        <CreatableSelect
          optionsList={jobPositionsList}
          label="Puesto"
          formName="job_position_id"
          createFn={(params) => createJobPosition({ ...params, company_id: reservationForm?.getFieldValue('company_id') || form.getFieldValue('company_id') })}
          form={form}
          required={true}
          onItemCreated={(id, item) => {
            onFieldsChange([{ name: ['job_position_id'], value: id, item }]);
            handleJobPositionCreated(item);
          }}
        />
      </Col>
    </Row>
  );
};

export default JobDataBlock;
